export default "__VITE_ASSET__810472ca__"